var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.54,
    y: 10.748,
    width: 27,
    height: 27,
    rx: 1.5,
    fill: "#63C7C9",
    stroke: "#73737B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.54 10.248C13.54 7.76277 15.5548 5.74805 18.04 5.74805C20.5253 5.74805 22.54 7.76277 22.54 10.248C22.54 12.7333 20.5253 14.748 18.04 14.748C15.5548 14.748 13.54 12.7333 13.54 10.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.54 10.248C25.54 7.76277 27.5548 5.74805 30.04 5.74805C32.5253 5.74805 34.54 7.76277 34.54 10.248C34.54 12.7333 32.5253 14.748 30.04 14.748C27.5548 14.748 25.54 12.7333 25.54 10.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.54 18.248C33.54 15.7628 35.5548 13.748 38.04 13.748C40.5253 13.748 42.54 15.7628 42.54 18.248C42.54 20.7333 40.5253 22.748 38.04 22.748C35.5548 22.748 33.54 20.7333 33.54 18.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.54 30.248C33.54 27.7628 35.5548 25.748 38.04 25.748C40.5253 25.748 42.54 27.7628 42.54 30.248C42.54 32.7333 40.5253 34.748 38.04 34.748C35.5548 34.748 33.54 32.7333 33.54 30.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.54 38.248C25.54 35.7628 27.5548 33.748 30.04 33.748C32.5253 33.748 34.54 35.7628 34.54 38.248C34.54 40.7333 32.5253 42.748 30.04 42.748C27.5548 42.748 25.54 40.7333 25.54 38.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.54 38.248C13.54 35.7628 15.5548 33.748 18.04 33.748C20.5253 33.748 22.54 35.7628 22.54 38.248C22.54 40.7333 20.5253 42.748 18.04 42.748C15.5548 42.748 13.54 40.7333 13.54 38.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54004 30.248C5.54004 27.7628 7.55476 25.748 10.04 25.748C12.5253 25.748 14.54 27.7628 14.54 30.248C14.54 32.7333 12.5253 34.748 10.04 34.748C7.55476 34.748 5.54004 32.7333 5.54004 30.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54004 18.248C5.54004 15.7628 7.55476 13.748 10.04 13.748C12.5253 13.748 14.54 15.7628 14.54 18.248C14.54 20.7333 12.5253 22.748 10.04 22.748C7.55476 22.748 5.54004 20.7333 5.54004 18.248Z",
    fill: "white",
    stroke: "#73737B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.54,
    y: 10.748,
    width: 27,
    height: 27,
    rx: 1.5,
    fill: "#63C7C9",
    stroke: "#73737B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.a135e486.svg";
export { ForwardRef as ReactComponent };